// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { env } from './.env';

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
export const environment = {
  production: false,
  envName: 'localhost',
  hmr: true,
  version: env.npm_package_version,
  name: 'PE PRO dev',
  serverUrl: '/api',
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US'],
  appType: 'pe',
  firebase: {
    apiKey: 'AIzaSyAhEhhVKSpuv-uc-vrpfacJVm38dVWL7os',
    authDomain: 'ekc-app.firebaseapp.com',
    databaseURL: 'https://ekc-app.firebaseio.com',
    projectId: 'ekc-app',
    storageBucket: 'ekc-app.appspot.com',
    messagingSenderId: '288907562496',
    appId: '1:288907562496:web:584019307cb3119f8d52e5',
    measurementId: 'G-54C8LSXZKG',
  },
  csvBox: {
    apiKey: 'YyDEemnX2lXvhBAFyXH9LBqrZWLJHX',
  },
  sentryDSN: 'https://31b3ef3b1d104adcb7f5b3c9abb9b17b@o440945.ingest.sentry.io/5410648',
  previewUrlsRegex: /^https:\/\/(ekc-staging|ekc-app)--.*\.web\.app/,
  stagingUrlsRegex: /^https:\/\/.*\.(pepro\.app|onlinepe\.co\.uk)/,
  productionUrls: ['https://pepro.app', 'https://onlinepe.co.uk'],
  sentryProject: 'pe-pro',
  cloudflareVideoUrl: 'https://customer-w24ytoxcxz7ffbty.cloudflarestream.com',
  configCatSDK: '_aPbCFYpVEqKc3IjdtsJ4w/zT5nGZ_9mky8VobDPHwq4A',
  useEmulators: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
